import { useNavigate } from 'react-router';
import { EventNames } from '../utils/trackingEvents';
import useTracking, { TrackingEventData } from './useTracking';

export const useGoBack = () => {
  const navigate = useNavigate();
  const { track } = useTracking();

  const goBack = (options?: {
    popCount?: number;
    fallbackPath?: string;
    trackingData?: TrackingEventData;
  }) => {
    if (options?.trackingData) {
      track(EventNames.BackButtonClick, options?.trackingData);
    }

    const popCount = options?.popCount ?? 1;
    const historyIdx = window.history.state?.idx ?? 0;

    if (historyIdx >= popCount) {
      navigate(popCount * -1);
      return;
    }

    navigate(options?.fallbackPath ?? '/app', {
      replace: true,
    });
  };

  return { goBack };
};
